export default [
      {
        path: "/Changelog/Index",
        name: "ChangelogIndex",
        component: () => import("@/components/Changelog/Index.vue"),
        meta: {
          title:'ChangelogIndex',
          menuTitle: "Changelog",
          name: "ChangelogIndex",
          requiresAuth: true,
        },
        props: true,
      },
      {
        path: "/Changelog/Editor",
        name: "ChangelogEditor",
        component: () => import("@/components/Changelog/Editor.vue"),
        meta: {
          title:'ChangelogEditor',
          menuTitle: "Changelog",
          name: "ChangelogEditor",
          requiresAuth: true,
        },
        props: true,
      },
  ];
  